import { loader } from 'graphql.macro';
import * as Sentry from '@sentry/browser';
import get from 'lodash/get';

import { memberClient } from 'src/config/Apollo';

const GET_MEMBER_CONVERSATION_UUID = loader('src/pages/documents/GetMemberConversation.gql');

export const findConversationUuid = async (memberUuid: string, coachUuid: string) => {
  try {
    const mostRecentConvo = await memberClient.query({
      query: GET_MEMBER_CONVERSATION_UUID,
      variables: {
        memberUuid,
        coachUuid,
      },
    });

    const uuid = get(mostRecentConvo, 'data.coachAssignments.0.conversation.uuid');

    if (!uuid) {
      throw new Error('Received invalid data from getMemberConversation query');
    }

    return uuid;
  } catch (err) {
    Sentry.captureException(err);
  }
};
